import React, { useState, useEffect, useRef, useCallback } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import PriceCalculator from "@heartinz/gst_india_product_price_calculator";
import TotalCalculator from "@heartinz/checkout_billing_price_validator";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useNetwork } from "../../../context/NetworkContext";
import { usePermission } from "../../../context/PermissionContext";
import { useContextApi } from "../../../context/ContextApi";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import AddProductSearch from "../sale/AddProductSearch";
import PaymentConfirmPopup from "./Payment";
import AddStockModel from "./AddStockModal";
import AddSupplier from "../supplier/AddSupplier";
import EditSupplier from "../supplier/EditSupplier";
import EditStockModel from "./EditStockModal";
import { useLocation, useNavigate } from "react-router-dom";
import AddNewProduct from "./AddNewProduct";
import AddService from "./AddService";
import EditService from "./EditService";
import AddPurchase from "./AddPurchase";
import SearchInput from "../../../constants/SearchInput";
import UpdateQty from "./UpdateQty";
import ConfirmSubmitModal from "./ConfirmSubmitModal";
import { toSecondaryQuantity } from "@heartinz/finance";
import ProductSearchList from "../../../constants/ProductSearchList";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useAuth } from "../../../context/AuthProvider";
import {
  AddIcon,
  ArrowBackIcon,
  CalendarIcon,
  CheckIcon,
  DeleteIcon,
  EditIcon,
  LineDoubleIcon,
  LniChevronRightIcon,
  MinusIcon,
  NotepadIcon,
  PhoneIcon,
  StockAddIcon,
  UserIcon,
  XIcon,
} from "../../../constants/Icons";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";

const Purchase = ({ onDone, isActive }) => {
  const { checkNetwork } = useNetwork();
  const { isUser } = useAuth();
  const navigate = useNavigate();
  const {
    hasModulePermission,
    permission,
    blockedPermissions,
    viewOption,
    customerGroups,
    globelPopupOpen,
  } = usePermission();
  const {
    handleSuggestEstimate,
    estimateSuggest,
    setEstimateSuggest,
    handleSuggestService,
    serviceNameSuggest,
    setServiceNameSuggest,
  } = useContextApi();
  const location = useLocation();
  const serverTime = GetServerLiveTime();
  // const iso = serverTime.toISOString();
  const [isCreating, setIsCreating] = useState(false);
  const isEditMode = useRef(false);
  const [isTabsReady, setIsTabsReady] = useState(false);
  const isReload = useRef(true);
  const datePickerRef = useRef(null);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [purchaseNo, setPurchaseNo] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [openedFromList, setOpenedFromList] = useState(false);
  const [purchaseData, setPurchaseData] = useState(null);
  const [selectedProduct, setselectedProduct] = useState(null);
  const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);
  const [purchaseIdForSubmit, setPurchaseIdForSubmit] = useState(null);
  const [selectedPurchaseOption, setSelectedPurchaseOption] = useState("PURCHASE");
  const [isRounded, setIsRounded] = useState(false);
  // const purchaseId = location.state?.purchaseId;
  // const purchaseData = location.state?.purchaseData;
  // console.log("purchaseId", purchaseId);
  // console.log("purchaseData", purchaseData);
  const showAlert = useShowAlert();
  const hasFetched = useRef(false);
  const [isPreLoading, setPreLoading] = useState(false);
  const [numberSuggest, setNumberSuggest] = useState([]);
  // const [cart, setCart] = useState([]);
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [productSuggestions, setProductSuggestions] = useState([]);
  const barcodeRef = useRef(null);
  const suggestionsRef = useRef(null);
  const customerSuggestionsRef = useRef(null);
  const [isbtnLoading, setButtonLoading] = useState(false);
  const [error, setErrors] = useState({});
  const { storeSettings } = usePermission();
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [isCustomerData, setCustomerData] = useState(null);
  // const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [totalPayable, setTotalPayable] = useState(0);
  const [totalMRP, setTotalMRP] = useState(0);
  // const [totalDiscount, setTotalDiscount] = useState(0);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [totalSaleprice, setTotalSalePrice] = useState(0);
  const [totalSoldprice, setTotalSoldPrice] = useState(0);
  const [totalTaxamount, setTotalTaxAmount] = useState(0);
  const [totalBaseprice, setTotalBasePrice] = useState(0);
  const [totalQty, setTotalQuantity] = useState(0);
  const [totalSaleRes, setSaleTotals] = useState(0);
  // const [totalSoldRes, setSoldTotals] = useState(0);
  const [isSaleModalOpen, setSaleModalOpen] = useState(false);
  const [cash, setCash] = useState(0);
  const [card, setCard] = useState(0);
  const [online, setOnline] = useState(0);
  const [upi, setUpi] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [paylater, setPaylater] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [balance, setBalance] = useState(totalPayable);
  const [isStockModalOpen, setStockModalOpen] = useState(false);
  // const [isStockData, setStockData] = useState(null);
  const [isSoldPirceModalOpen, setSoldPriceModalOpen] = useState(false);
  const [isProductData, setProductData] = useState(null);
  const [isQuantityData, setQunatityItem] = useState(null);
  const [isQuantityIndex, setQunatityIndex] = useState(null);
  const [isQuantityModalOpen, setQuantityModalOpen] = useState(false);
  const [noteSuggest, setNoteSuggest] = useState([]);

  const [isChangeModalOpen, setChangeModalOpen] = useState(false);
  const [isChangeData, setChangeData] = useState({});

  const [isModeModalOpen, setModeModalOpen] = useState(false);

  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [currentNoteProduct, setCurrentNoteProduct] = useState(null);

  const [isServiceModalOpen, setServiceModalOpen] = useState(false);
  const [isProductModalOpen, setProductModalOpen] = useState(false);
  const [isEditSalePriceData, setEditSalePriceData] = useState(null);
  const [isEditSalePriceModelOpen, setEditSalePriceModelOpen] = useState(false);
  const [isEditServiceModalOpen, setEditServiceModalOpen] = useState(false);
  const [isServiceData, setServiceData] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const suggestionRefs = useRef([]);
  const cashRef = useRef(null);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [lastSale, setLastSale] = useState(null);
  const [categories, setCategories] = useState([]);
  const dropdownRef = useRef();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);
  const [groupName, setGroupName] = useState(customerGroups);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [totalPurchasePrice, setTotalPurchasePrice] = useState(0);
  const [submitType, setSubmitType] = useState(null); // "DRAFT" | "FINAL"
  const favouriteRefs = useRef([]);

  const [purchaseItems, setPurchaseItems] = useState([]);
  const [purchaseServices, setPurchaseServices] = useState([]);
  const [addToStockMap, setAddToStockMap] = useState({});

  const [showNewProduct, setShowNewProduct] = useState(false);
  const [brandSuggest, setBrandSuggest] = useState([]);
  const [isAnyInputFocused, setIsAnyInputFocused] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const hasInitialized = useRef(false);

  const [totalSoldRes, setTotalSoldRes] = useState({
    totalmrp: 0,
    totaldiscount: 0,
    totalsaleprice: 0,
    grandtotal: 0,
  });

  const date = new Date();
  const isofor = date.toISOString();
  const currentDate = DateConverter.ISOToDisplayFormat(
    DateConverter.convertToTimeZone(isofor, "Asia/Kolkata"),
  ).date;

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    var cashAmt = CurrencyConverter.toSubunit(cash || 0, "INR");
    var cardAmt = CurrencyConverter.toSubunit(card || 0, "INR");
    var upiAmt = CurrencyConverter.toSubunit(upi || 0, "INR");
    var disAmt = CurrencyConverter.toSubunit(discount || 0, "INR");
    var onlineAmt = CurrencyConverter.toSubunit(online || 0, "INR");
    var paylaterAmt = CurrencyConverter.toSubunit(paylater || 0, "INR");
    var payObject = {
      cashamount: cashAmt,
      cardamount: cardAmt,
      onlineamount: onlineAmt,
      discountamount: disAmt,
      upiamount: upiAmt,
      paylateramount: paylaterAmt,
    };
    var totalVal = TotalCalculator.validateCheckout(totalPayable, payObject);
    setTotalPaid(totalVal.totalPaid);
    setBalance(totalVal.balance);
    if (totalVal.balance < 0) {
      setPaylater(0);
    }
  }, [cash, card, online, upi, discount, paylater, totalPayable]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchSupplierById = async (supplierId) => {
    try {
      if (!supplierId) return;

      const res = await AxiosInstance.get(`module/supplier/${supplierId}`);
      const supplier = res.data.results;

      setSelectedCustomer(supplier);
      setCustomerData(supplier);
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const handleBrandSuggest = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/brand/suggestion`,
      );
      const result = response?.data?.results;
      setBrandSuggest(result);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleNoteOpen = (status) => {
    setNoteOpen(status);
  };

  const handleCreatePurchase = async (data) => {
    try {
      if (!checkNetwork()) return;

      const payload = {
        purchaseNo: data.purchaseNo,
        purchaseDate: data.purchaseDate,
        supplierId: data.supplierId,
      };

      const response = await AxiosInstance.post("module/purchase", payload);
      const createdPurchase = response?.data?.results;

      if (createdPurchase?.supplierId) {
        fetchSupplierById(createdPurchase.supplierId);
      }

      if (!createdPurchase?._id) {
        showAlert("error", "Purchase ID not received");
        return;
      }

      showAlert("success", "Purchase created successfully");

      sessionStorage.setItem("purchaseId", createdPurchase._id);

      setPurchaseData(createdPurchase);
      setIsCreating(false); // ✅ store locally
      setAddModalOpen(false);
      suggestionsRef.current?.focus();
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleAddPurchaseClose = () => {
    setAddModalOpen(false);

    onDone?.();
  };

  const handleProductSearch = (term) => {
    setProductSearchTerm(term);
    if (term.trim() === "") {
      setProductSuggestions([]);
      return;
    }
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        setPreLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;

        const response = await AxiosInstance.get(
          `module/product/search-hybrid-active?searchtxt=${term}`,
          { signal: controllerRef.current.signal },
        );
        if (currentId === requestIdRef.current) {
          setProductSuggestions(response.data.results || []);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          console.error("API Error:", error);
        }
      } finally {
        setPreLoading(false);
      }
    }, 200);
  };

  const handleSelectProduct = async (product, fromModal = false) => {
    try {
      setProductSearchTerm("");
      setProductSuggestions([]);

      const response = await AxiosInstance.get(
        `module/product/view-product/${product._id}`,
      );
      const productDetails = response.data.results;

      setSoldPriceModalOpen(true);
      setProductData(productDetails);

      // ✅ close only if it was selected from modal
      if (fromModal) {
        setProductSearchTerm("");
        handleProductClose();
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleStockAdded = (updatedData, selectedProduct) => {
    const product = {
      ...selectedProduct,
      ...updatedData,
    };

    // ✅ detect new product
    const isNew = !selectedProduct?._id;

    addItemToPurchase(product, isNew);
    handleSoldPriceClose();
  };

  const addNewProductToPurchase = async (item) => {
    // 👉 Open stock modal with new product
    setProductData(item);
    setSoldPriceModalOpen(true);
  };

  const handleSelectNewProduct = (value) => {
    const isBarcode = /^[0-9]+$/.test(value); // simple check

    setselectedProduct({
      title: isBarcode ? "" : value,
      code: isBarcode ? value : "",
      saleprice: 0,
    });

    setProductData({
      code: isBarcode ? value : "",
      hsnsac: "",
      title: isBarcode ? "" : value,
      note: "",
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      landingcost: 0,
      isLock: "SALEPRICE",
      lcmultiplayer: 0,
      finalLandingCost: 0,
      manufacturedate: "",
      expiredate: "",
    });
  };

  const addItemToPurchase = async (item, isNew = false) => {
    // console.log("item", item);
    try {
      // ✅ Duplicate check
      const isDuplicate = purchaseItems.some((p) => {
        if (isNew) {
          return (
            p.title?.toLowerCase().trim() ===
              item.title?.toLowerCase().trim() &&
            Number(p.saleprice) ===
              CurrencyConverter.toSubunit(Number(item.saleprice || 0), "INR")
          );
        } else {
          return p.productId === item._id;
        }
      });

      if (isDuplicate) {
        showAlert("Item already exists in purchase", "error");
        return;
      }

      const isChecked = item.addToStock ?? addToStockMap[item.code] ?? true;

      const purchaseItem = {
        ...(isNew
          ? {
              code: item.code,
              hsnsac: item.hsnsac,
              title: item.title,
              brandId: item?.brandId,
              searchTag: item?.searchTag,
              note: item?.note,
            }
          : {
              productId: item._id,
            }),

        mrp: CurrencyConverter.toSubunit(item.mrp || 0, "INR"),
        saleprice: CurrencyConverter.toSubunit(item.saleprice || 0, "INR"),
        baseprice: CurrencyConverter.toSubunit(item.baseprice || 0, "INR"),
        manufactureDate: item.manufacturedate,
        expireDate: item.expiredate,

        taxpercentage: Number(item.taxpercentage || 0),
        isLock: item.isLock,
        quantity: Number(item.quantity),

        lineTotalPurchaseAmountWithTax: CurrencyConverter.toSubunit(
          item.purchaseWithTax || 0,
          "INR",
        ),

        lineTotalPurchaseAmountWithOutTax: CurrencyConverter.toSubunit(
          item.purchaseWithoutTax || 0,
          "INR",
        ),

        lineTotalPurchaseAmountLock: item.totalPurchaseAmountLock,

        addToStock: isChecked,
      };

      // ✅ Unit config
      // ✅ pass full unitConfig
      if (item.unitConfig) {
        purchaseItem.unitConfig = {
          ...item.unitConfig,
          // ensure numbers are correct if needed
          // conversion: item.unitConfig.conversion
          //   ? Number(item.unitConfig.conversion)
          //   : undefined,
        };
      }

      if (item.unitConfig) {
        purchaseItem.isSecondaryUnit = item.isSecondaryUnit;
      }

      const res = await AxiosInstance.patch(
        `module/purchase/items/${purchaseData._id}`,
        { purchaseItem },
      );
      const data = res.data.results;
      setPurchaseItems((prev) => [...prev, ...res.data.results.purchaseItems]);
      setTotalSoldRes({
        totalmrp: data.grandTotal?.totalPurchaseMrp || 0,
        totaldiscount: data.grandTotal?.totalPurchaseDiscount || 0,
        totalsaleprice: data.grandTotal?.totalPurchasePrice || 0,
        grandtotal: data.grandTotal?.grandtotal || 0,
      });
      setIsRounded(data?.isRounded || false);
      showAlert("success", "Product Added successfully.");
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const handleStockItemUpdate = (updatedStock, purchaseItemId) => {
    // console.log("Updated Stock for edit:", updatedStock);

    updateProductInPurchase(updatedStock, purchaseItemId);

    setEditSalePriceData(false);
  };

  const updateProductInPurchase = async (product, purchaseItemId, qty) => {
    try {
      const isChecked =
        product.addToStock ?? addToStockMap[product.code] ?? true;

      // const quantity = Number(qty || product.quantity);

      // const lineWithTax = CurrencyConverter.toSubunit(
      //   Number(product.purchaseamount || 0),
      //   "INR",
      // );

      // const lineWithoutTax = CurrencyConverter.toSubunit(
      //   Number(product.purchaseBase || 0),
      //   "INR",
      // );

      const body = {
        purchaseItem: {
          mrp: CurrencyConverter.toSubunit(product.mrp || 0, "INR"),
          saleprice: CurrencyConverter.toSubunit(product.saleprice || 0, "INR"),
          baseprice: CurrencyConverter.toSubunit(product.baseprice || 0, "INR"),

          taxpercentage: Number(product.taxpercentage || 0),
          isLock: product.isLock,
          quantity: Number(product.quantity || 0),

          lineTotalPurchaseAmountWithTax: CurrencyConverter.toSubunit(
            product.purchaseWithTax || product.purchaseamount || 0,
            "INR",
          ),

          lineTotalPurchaseAmountWithOutTax: CurrencyConverter.toSubunit(
            product.purchaseWithoutTax || product.purchaseamount || 0,
            "INR",
          ),

          lineTotalPurchaseAmountLock:
            product.totalPurchaseAmountLock || "WITHOUTTAX",

          ...(product.manufacturedate && {
            manufactureDate: product.manufacturedate,
          }),

          ...(product.expiredate && {
            expireDate: product.expiredate,
          }),

          ...(product.unitConfig && {
            unitConfig: product.unitConfig,
          }),

          ...(product.unitConfig && {
            isSecondaryUnit: product.isSecondaryUnit,
          }),

          addToStock: isChecked,
        },
      };
      const res = await AxiosInstance.patch(
        `module/purchase/${purchaseData._id}/item/${purchaseItemId}`,
        body,
      );
      const data = res.data.results;
      // ✅ Replace updated item instead of pushing
      setPurchaseItems((prev) =>
        prev.map((item) =>
          item._id === purchaseItemId
            ? res.data.results.purchaseItems[0]
            : item,
        ),
      );
      setAddToStockMap((prev) => ({
        ...prev,
        [product.code]: isChecked,
      }));
      setTotalSoldRes({
        totalmrp: data.grandTotal?.totalPurchaseMrp || 0,
        totaldiscount: data.grandTotal?.totalPurchaseDiscount || 0,
        totalsaleprice: data.grandTotal?.totalPurchasePrice || 0,
        grandtotal: data.grandTotal?.grandtotal || 0,
      });
      setIsRounded(data?.isRounded || false);
      showAlert("success", "Product Updated successfully.");
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const updateAddToStock = async (purchaseItemId, value, code) => {
    try {
      const body = {
        purchaseItem: {
          addToStock: value,
        },
      };

      const res = await AxiosInstance.patch(
        `module/purchase/${purchaseData._id}/item/${purchaseItemId}`,
        body,
      );

      const updatedItem = res?.data?.results?.purchaseItems?.[0];

      // ✅ 1. Update purchaseItems (SOURCE OF TRUTH)
      if (updatedItem) {
        setPurchaseItems((prev) =>
          prev.map((item) =>
            item._id === purchaseItemId ? updatedItem : item,
          ),
        );
      }

      // ✅ 2. Sync map (UI state)
      setAddToStockMap((prev) => ({
        ...prev,
        [code]: value,
      }));
      showAlert("success", "AddToStock Updated successfully.");
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const addServiceToPurchase = async (service) => {
    // console.log("Adding service to purchase:", service);
    try {
      const quantity = service.quantity || 1;

      // ✅ Decide lock from isLock
      const taxLock = service.isLock === "BASEPRICE" ? "WITHOUTTAX" : "WITHTAX";

      // ✅ Calculate price
      const saleRes = PriceCalculator.getAllPriceList(
        service.mrp, // fallback for mrp
        service.saleprice,
        service.baseprice,
        service.taxpercentage,
        quantity,
        service.isLock, // 🔥 IMPORTANT: keep original lock here
      );

      // console.log("Calculated saleRes:", saleRes);

      const body = {
        purchaseService: {
          // serviceId: service._id,
          title: service.title,
          hsnsac: service.hsnsac,
          description: service.description,
          taxpercentage: service.taxpercentage,
          saleprice: saleRes.salePrice,
          baseprice: saleRes.basePrice,
          quantity: quantity,
          isLock: service.isLock,
          lineTotalPurchaseAmountWithTax: saleRes.lineTotalSalePrice,
          lineTotalPurchaseAmountWithOutTax: saleRes.lineTotalBasePrice,
          lineTotalPurchaseAmountLock: taxLock,
          totalAmount: saleRes.lineGrandTotal,
          ...(service?.unitConfig && {
            unitLocked: true,
            unitConfig: service?.unitConfig,
          }),
        },
      };

      const res = await AxiosInstance.patch(
        `module/purchase/services/${purchaseData._id}`,
        body,
      );
      const data = res.data.results;
      setPurchaseServices((prev) => [
        ...prev,
        ...res.data.results.purchaseServices,
      ]);

      setTotalSoldRes({
        totalmrp: data.grandTotal?.totalPurchaseMrp || 0,
        totaldiscount: data.grandTotal?.totalPurchaseDiscount || 0,
        totalsaleprice: data.grandTotal?.totalPurchasePrice || 0,
        grandtotal: data.grandTotal?.grandtotal || 0,
      });
      setIsRounded(data?.isRounded || false);
      showAlert("success", "Service added successfully.");
    } catch (err) {
      handleError(err, showAlert);
    }
  };
  const UpdateServiceToPurchase = async (service) => {
    // console.log("Updating service in purchase:", service);

    try {
      const quantity = service.quantity || 1;

      // ✅ Decide lock from isLock
      const taxLock = service.isLock === "BASEPRICE" ? "WITHOUTTAX" : "WITHTAX";

      // ✅ Calculate price
      const saleRes = PriceCalculator.getAllPriceList(
        service.saleprice || service.baseprice, // fallback for mrp
        service.saleprice,
        service.baseprice,
        service.taxpercentage,
        quantity,
        service.isLock, // 🔥 IMPORTANT: keep original lock here
      );

      // console.log("Calculated saleRes:", saleRes);

      const body = {
        purchaseService: {
          // serviceId: service._id,
          title: service.title,
          hsnsac: service.hsnsac,
          description: service.description,
          taxpercentage: service.taxpercentage,
          lineTotalPurchaseAmountWithTax: saleRes.lineGrandTotal,
          lineTotalPurchaseAmountWithOutTax: saleRes.lineTotalBasePrice,
          lineTotalPurchaseAmountLock: taxLock,
          totalAmount: saleRes.lineGrandTotal,
        },
      };

      const res = await AxiosInstance.patch(
        `module/purchase/${purchaseData._id}/service/${service._id}`,
        body,
      );
      const data = res.data.results;
      // ✅ FIX: get single object
      const updatedService = res.data.results.purchaseServices[0];

      // ✅ Replace correctly
      // setPurchaseServices((prev) =>
      //   prev.map((item, i) => (i === service.cIndex ? updatedService : item)),
      // );

      setPurchaseServices((prev) =>
        prev.map((item) =>
          item._id === updatedService._id ? updatedService : item,
        ),
      );
      setTotalSoldRes({
        totalmrp: data.grandTotal?.totalPurchaseMrp || 0,
        totaldiscount: data.grandTotal?.totalPurchaseDiscount || 0,
        totalsaleprice: data.grandTotal?.totalPurchasePrice || 0,
        grandtotal: data.grandTotal?.grandtotal || 0,
      });
      setIsRounded(data?.isRounded || false);

      setEditServiceModalOpen(false);
      showAlert("success", "Service  Updated successfully.");
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const handleSelectCustomer = async (customer) => {
    try {
      if (!checkNetwork()) return;

      // 1. Get full supplier details
      const response = await AxiosInstance.get(
        `module/supplier/${customer._id}`,
      );

      const fullCustomer = response.data.results;

      // 2. Update UI state
      setSelectedCustomer(fullCustomer);
      setCustomerData(fullCustomer);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);

      // ❌ REMOVE THIS BLOCK COMPLETELY
      // updateActiveCart((cart) => ({
      //   ...cart,
      //   customer: fullCustomer,
      // }));

      // 3. PATCH supplier to purchase (MAIN SOURCE OF TRUTH)
      if (purchaseData._id) {
        await AxiosInstance.patch(`module/purchase/${purchaseData._id}`, {
          supplierId: fullCustomer._id,
        });
      }
      showAlert("success", "Supplier Added successfully.");
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  // const updateQuantity = async (item, Uindex, qty) => {
  //   console.log("Updating quantity for item:", item, "New quantity:", qty);
  //   try {
  //     const body = {
  //       purchaseItem: {
  //         productId: item?.productId,
  //         quantity: qty,
  //       },
  //     };

  //     const res = await AxiosInstance.patch(
  //       `module/purchase/${purchaseData._id}/item/${item._id}`,
  //       body,
  //     );

  //     setPurchaseItems(res.data.results.purchaseItems);
  //   } catch (err) {
  //     handleError(err, showAlert);
  //   }
  // };

  const updateQuantity = async (item, Uindex, qty) => {
    try {
      const body = {
        purchaseItem: {
          productId: item?.productId,
          quantity: qty,
        },
      };

      const res = await AxiosInstance.patch(
        `module/purchase/${purchaseData._id}/item/${item._id}`,
        body,
      );
      const data = res.data.results;
      // 👇 API returns only updated item
      const updatedItem = res?.data?.results?.purchaseItems?.[0];

      if (!updatedItem) return;

      // ✅ Merge into existing state using _id
      setPurchaseItems((prevItems) =>
        prevItems.map((prod) =>
          prod._id === updatedItem._id ? updatedItem : prod,
        ),
      );
      setTotalSoldRes({
        totalmrp: data.grandTotal?.totalPurchaseMrp || 0,
        totaldiscount: data.grandTotal?.totalPurchaseDiscount || 0,
        totalsaleprice: data.grandTotal?.totalPurchasePrice || 0,
        grandtotal: data.grandTotal?.grandtotal || 0,
      });
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const handleProductClose = () => {
    suggestionsRef.current?.focus();
    setProductModalOpen(false);
  };

  const handleOutsideClick = (e) => {
    if (suggestionsRef.current && !suggestionsRef.current.contains(e.target)) {
      setProductSuggestions([]);
      setProductSearchTerm("");
    }
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target)
    ) {
      setCustomerSuggestions([]);
      setCustomerSearchTerm("");
    }
  };

  const handleCancel = () => {
    onDone?.();
  };

  // const handleStockClose = () => {
  //   setStockModalOpen(false);
  //   if (viewOption("saleSettings", "isScanBarcode")) {
  //     barcodeRef.current?.focus();
  //   } else {
  //     suggestionsRef.current?.focus();
  //   }
  //   setStockData(null);
  // };

  const handleQuantity = async (item, Uindex) => {
    setQuantityModalOpen(true);
    setQunatityItem(item);
    setQunatityIndex(Uindex);
  };

  const handleQuantityClose = () => {
    suggestionsRef.current?.focus();
    setQuantityModalOpen(false);
    setQunatityItem(null);
    setQunatityIndex(null);
  };

  const handleQuantityUpdate = async (item, Uindex, newQty) => {
    updateQuantity(item, Uindex, newQty);
    handleQuantityClose();
  };

  const handleSoldPriceClose = () => {
    suggestionsRef.current?.focus();

    setSoldPriceModalOpen(false);
  };

  const editSalePriceClose = () => {
    suggestionsRef.current?.focus();
    setEditSalePriceModelOpen(false);
  };

  const handleProductNote = (item) => {
    setCurrentNoteProduct(item);
    setNoteModalOpen(true);
  };

  const handleCustomerModalOpen = () => {
    setSelectedCustomer(null);
    setCustomerModalOpen(true);
  };

  const handleCustomerModalClose = () => {
    suggestionsRef.current?.focus();
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleCustomerAdd = async (newData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      const response = await AxiosInstance.post(`module/supplier`, data);
      showAlert("success", "Supplier added successfully.");
      handleResetCustomer();
      handleSelectCustomer(response.data.results);
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const openEditModal = (cItem) => {
    if (
      blockedPermissions("CUSTOMER:viewDetails") ||
      permission === undefined
    ) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "number",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "website",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }
    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/supplier/${updatedData._id}`,
        data,
      );

      showAlert("success", "Supplier updated successfully.");
      setCustomerData(response.data.results);
      setSelectedCustomer((prev) => ({
        ...prev,
        ...response.data.results,
      }));
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        if (errorMessage.includes("ReferenceId already exists")) {
          fieldError.referenceid = "Reference ID already exists .";
        } else if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const closeEditModal = () => {
    suggestionsRef.current?.focus();
    setEditData(null);
    setEditModalOpen(false);
  };

  const handleResetCustomer = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && customerSearchTerm.trim()) {
      handleCustomerModalOpen();
    }
  };

  const handleServiceOpen = async () => {
    // await handleSuggestEstimate();
    setServiceModalOpen(true);
  };

  const handleServiceClose = () => {
    suggestionsRef.current?.focus();
    setServiceModalOpen(false);
  };

  const editItem = async (cItem, index) => {
    // console.log("Editing item:", cItem, "at index:", index);
    setServiceData({
      ...cItem,
      // mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
      saleprice: CurrencyConverter.toCurrency(
        cItem.lineTotalPurchasePriceWithTax,
        "INR",
      ),
      // discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
      baseprice: CurrencyConverter.toCurrency(
        cItem.lineTotalPurchasePriceWithoutTax,
        "INR",
      ),
      isLock:
        cItem.lineTotalPurchaseAmountLock === "WITHOUTTAX"
          ? "BASEPRICE"
          : "SALEPRICE",
      // taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
      taxpercentage: cItem.purchaseTaxPercentage,
      cIndex: index,
    });
    // await handleSuggestEstimate();
    setEditServiceModalOpen(true);
  };

  const removeItem = async (itemId) => {
    try {
      const res = await AxiosInstance.delete(
        `module/purchase/${purchaseData._id}/item/${itemId}`,
      );

      if (res?.data?.status) {
        setPurchaseItems((prev) => prev.filter((item) => item._id !== itemId));
      }
      const data = res.data.results;
      setTotalSoldRes({
        totalmrp: data?.grandTotal?.totalPurchaseMrp || 0,
        totaldiscount: data?.grandTotal?.totalPurchaseDiscount || 0,
        totalsaleprice: data?.grandTotal?.totalPurchasePrice || 0,
        grandtotal: data?.grandTotal?.grandtotal || 0,
      });
      showAlert("success", "Product removed successfully.");
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const removeService = async (serviceId) => {
    // console.log("Removing service with ID:", serviceId);

    try {
      const res = await AxiosInstance.delete(
        `module/purchase/${purchaseData._id}/service/${serviceId}`,
      );

      if (res?.data?.status) {
        setPurchaseServices((prev) =>
          prev.filter((service) => service._id !== serviceId),
        );
      }

      const data = res.data.results;

      setTotalSoldRes({
        totalmrp: data?.grandTotal?.totalPurchaseMrp || 0,
        totaldiscount: data?.grandTotal?.totalPurchaseDiscount || 0,
        totalsaleprice: data?.grandTotal?.totalPurchasePrice || 0,
        grandtotal: data?.grandTotal?.grandtotal || 0,
      });
      showAlert("success", "Service removed successfully.");
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const salepriceEdit = (cItem, index) => {
    // console.log("Editing sale price for item:", cItem, "at index:", index);
    setEditSalePriceData({
      ...cItem,
      mrp: cItem.purchaseMrp,
      saleprice: cItem.saleAmountList.salePrice,
      taxpercentage: cItem.purchaseTaxPercentage,
      cIndex: index,
    });
    setEditSalePriceModelOpen(true);
  };

  const handleSuggestNote = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/note/suggestion?language=en`,
      );

      setNoteSuggest(response.data.results || []);
      // setShowNotePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleEditServiceClose = () => {
    suggestionsRef.current?.focus();
    setEditServiceModalOpen(false);
  };

  // const handleProductKeyDown = (e) => {
  //   if (e.key === "ArrowDown") {
  //     e.preventDefault();
  //     setHighlightedIndex((prev) =>
  //       Math.min(prev + 1, productSuggestions.length - 1),
  //     );
  //   } else if (e.key === "ArrowUp") {
  //     e.preventDefault();
  //     setHighlightedIndex((prev) => Math.max(prev - 1, 0));
  //   } else if (e.key === "Enter") {
  //     e.preventDefault();

  //     if (productSearchTerm.trim() === "") {
  //       customerSuggestionsRef.current?.focus();
  //       return;
  //     }

  //     if (highlightedIndex >= 0) {
  //       const selected = productSuggestions[highlightedIndex];
  //       handleSelectProduct(selected);
  //       setShowProductDropdown(false);
  //       setProductSearchTerm("");
  //       setHighlightedIndex(-1);
  //     }
  //   }
  // };

  const handleProductKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, productSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmed = productSearchTerm.trim();

      if (!trimmed) {
        customerSuggestionsRef.current?.focus();
        return;
      }

      // ✅ CASE 1: चयनित suggestion
      if (highlightedIndex >= 0 && productSuggestions.length > 0) {
        const selected = productSuggestions[highlightedIndex];
        handleSelectProduct(selected);
      }
      // ✅ CASE 2: NO MATCH → OPEN ADD PRODUCT MODAL
      else {
        handleSelectNewProduct(trimmed); // prefill data
        setShowNewProduct(true); // open modal
      }

      // reset
      setShowProductDropdown(false);
      setProductSearchTerm("");
      setHighlightedIndex(-1);
    }
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        cashRef.current?.focus();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer.name.toLowerCase() === trimmedSearch.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        customerSuggestionsRef.current?.focus();
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (!isActive) return;
    suggestionsRef.current?.focus();
  }, [isActive]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleSuggestEstimate();
    if (hasModulePermission("SERVICE") || permission === undefined) {
      handleSuggestService();
    }
    handleSuggestNote();
    handleBrandSuggest();
  }, []);

  const addNewServiceName = (name) => {
    const trimmed = name?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = serviceNameSuggest?.some(
      (s) => s.serviceByName?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setServiceNameSuggest((prev) => [
        { _id: Date.now().toString(), serviceByName: trimmed },
        ...prev,
      ]);
    }
  };

  const handleSupplierSearch = (term) => {
    setCustomerSearchTerm(term);
    if (term.trim() === "") {
      setCustomerSuggestions([]);
      setCustomerData(null);
      return;
    }
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        setIsCustomerLoading(true);
        if (!checkNetwork()) return;
        controllerRef.current = new AbortController();
        const response = await AxiosInstance.get(
          `module/supplier/search?searchtxt=${encodeURIComponent(term.trim())}`,
          { signal: controllerRef.current.signal },
        );
        setCustomerSuggestions(response.data.results || []);
        const data = { phone: "", name: "" };
        if (/^\d+$/.test(term.trim())) {
          data.phone = term.trim();
        } else {
          data.name = term.trim();
        }
        setCustomerData(data);
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setIsCustomerLoading(false);
      }
    }, 200);
  };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleRemoveSupplier = async () => {
    try {
      const res = await AxiosInstance.delete(
        `module/purchase/supplier/${purchaseData._id}`,
      );

      // ✅ After successful API call, update UI
      setSelectedCustomer(null);
      setCustomerSearchTerm("");
      setShowCustomerDropdown(false);
      showAlert("success", "Supplier removed successfully.");
    } catch (error) {
      console.error("Failed to remove supplier:", error);
    }
  };

  const naviListEstimate = () => {
    navigate("/listpurchase" || "/dashboard");
    onDone?.();
  };

  const updatePurchaseField = async (field, value) => {
    if (!purchaseData?._id) return;

    let payloadValue = value;

    // ✅ Convert date
    if (field === "purchaseDate" && value) {
      const date = new Date(value);

      const existing = purchaseData.purchaseDate
        ? new Date(purchaseData.purchaseDate)
        : new Date();

      date.setHours(
        existing.getHours(),
        existing.getMinutes(),
        existing.getSeconds(),
        existing.getMilliseconds(),
      );

      payloadValue = date.toISOString();
    }

    try {
      const res = await AxiosInstance.patch(
        `module/purchase/${purchaseData._id}`,
        { [field]: payloadValue },
      );

      if (res?.data?.status) {
        // ✅ update only that field in main state
        setPurchaseData((prev) => ({
          ...prev,
          [field]: payloadValue,
        }));

        showAlert("success", "Purchase Details Updated.");
      } else {
        throw new Error("Update failed");
      }
    } catch (err) {
      handleError(err, showAlert);

      // 🔥 rollback ONLY changed field
      if (field === "purchaseNo") {
        setPurchaseNo(purchaseData.purchaseNo || "");
      }

      if (field === "purchaseDate") {
        setPurchaseDate(
          purchaseData.purchaseDate
            ? purchaseData.purchaseDate.slice(0, 10)
            : "",
        );
      }
    }
  };
  useEffect(() => {
    const handleArrowAndEnter = (e) => {
      // Only handle when search term is empty or suggestions list is empty
      if (!(productSearchTerm?.trim() === "")) return;
      if (!(productSuggestions?.length === 0)) return;
      if (!(customerSearchTerm?.trim() === "")) return;
      if (!(customerSuggestions?.length === 0)) return;
      if (!(favouriteRefs?.length === 0)) return;

      if (
        noteModalOpen ||
        isEditSalePriceModelOpen ||
        isEditServiceModalOpen ||
        isServiceModalOpen ||
        isProductModalOpen ||
        isEditModalOpen ||
        isCustomerModalOpen ||
        isModeModalOpen ||
        isChangeModalOpen ||
        isSaleModalOpen ||
        isSoldPirceModalOpen ||
        isQuantityModalOpen ||
        isStockModalOpen ||
        globelPopupOpen ||
        noteOpen ||
        isAnyInputFocused
      )
        return;

      if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

      e.preventDefault();

      const tableRows = Array.from(document.querySelectorAll("table tbody tr"));
      if (!tableRows.length) return;

      const currentRow = document.activeElement.closest("tr");
      let currentIndex = tableRows.indexOf(currentRow);

      // Handle Enter key
      if (e.key === "Enter") {
        if (currentIndex >= 0) {
          const item = tableRows[currentIndex].dataset.item
            ? JSON.parse(tableRows[currentIndex].dataset.item)
            : null;

          if (item) {
            if (item.imode === "SERVICE") {
              editItem(item, currentIndex);
            } else if (item.imode === "PRODUCT") {
              salepriceEdit(item, currentIndex);
            }
          }
        }
        return;
      }

      // Virtual -1: no row focused yet
      if (currentIndex === -1) {
        if (e.key === "ArrowDown") {
          tableRows[0].tabIndex = 0;
          tableRows[0].focus();
        } else if (e.key === "ArrowUp") {
          tableRows[tableRows.length - 1].tabIndex = 0;
          tableRows[tableRows.length - 1].focus();
        }
        return;
      }

      // Remove tabIndex from current row
      currentRow.tabIndex = -1;

      // Calculate next/previous index
      let nextIndex =
        e.key === "ArrowDown"
          ? (currentIndex + 1) % tableRows.length
          : (currentIndex - 1 + tableRows.length) % tableRows.length;

      const nextRow = tableRows[nextIndex];
      nextRow.tabIndex = 0;
      nextRow.focus();
    };

    window.addEventListener("keydown", handleArrowAndEnter);
    return () => window.removeEventListener("keydown", handleArrowAndEnter);
  }, [
    favouriteRefs,
    productSearchTerm,
    productSuggestions,
    noteModalOpen,
    isEditSalePriceModelOpen,
    isEditServiceModalOpen,
    isServiceModalOpen,
    isProductModalOpen,
    isEditModalOpen,
    isCustomerModalOpen,
    isModeModalOpen,
    isChangeModalOpen,
    isSaleModalOpen,
    isSoldPirceModalOpen,
    isQuantityModalOpen,
    isStockModalOpen,
    customerSuggestions,
    customerSearchTerm,
    globelPopupOpen,
    noteOpen,
    isAnyInputFocused,
  ]);

  const resetPurchaseState = () => {
    sessionStorage.removeItem("purchaseId");

    setPurchaseData(null);
    setPurchaseItems([]);
    setPurchaseServices([]);

    setSelectedCustomer(null);
    setCustomerData(null);

    setProductSearchTerm("");
    setProductSuggestions([]);

    setCustomerSearchTerm("");
    setCustomerSuggestions([]);

    setTotalPayable(0);
    setTotalMRP(0);
    setTotalSalePrice(0);
    setTotalSoldPrice(0);
    setTotalTaxAmount(0);
    setTotalBasePrice(0);
    setTotalQuantity(0);
    setSaleTotals(0);
    setTotalSoldRes({
      totalmrp: 0,
      totaldiscount: 0,
      totalsaleprice: 0,
      grandtotal: 0,
    });

    setCash(0);
    setCard(0);
    setOnline(0);
    setUpi(0);
    setDiscount(0);
    setPaylater(0);
    setTotalPaid(0);
    setBalance(0);

    setSelectedProducts([]);
    setAddToStockMap({});
    setPurchaseDate("");
    setSubmitType(null);

    // 🔥 IMPORTANT missing resets
    setNumberSuggest([]);
    setNoteSuggest([]);
    setBrandSuggest([]);
    setServiceNameSuggest([]);

    setHighlightedIndex(-1);
  };

  // useEffect(() => {
  //   if (!purchaseData) return;

  //   const { totalAmount = 0, balanceAmount = 0, totalPaid = 0 } = purchaseData;

  //   // ✅ Decide payable amount
  //   const payable = totalPaid > 0 ? balanceAmount : totalAmount;

  //   const roundedTotal = Math.round(payable);

  //   setTotalPayable(roundedTotal);
  //   setFormattedTotal(CurrencyConverter.toCurrency(roundedTotal || 0, "INR"));
  // }, [purchaseData]);

  // useEffect(() => {
  //   if (!purchaseId) return;

  //   const fetchPurchase = async () => {
  //     const res = await AxiosInstance.get(`module/purchase/${purchaseId}`);
  //     setPurchaseItems(res.data.results.purchaseItems);
  //   };

  //   fetchPurchase();
  // }, [purchaseId]);

  // useEffect(() => {
  //   if (location.state?.openCreateModal) {
  //     setAddModalOpen(true);
  //   }
  // }, [location.state]);

  useEffect(() => {
    if (!purchaseData?.purchaseDate) return;

    setPurchaseNo(purchaseData.purchaseNo || "");

    setPurchaseDate(dayjs(purchaseData.purchaseDate));
  }, [purchaseData]);

  useEffect(() => {
    if (location.state?.isEdit && location.state?.purchaseData) {
      isEditMode.current = true;
      const purchaseId = location.state.purchaseData._id;

      const fetchPurchase = async () => {
        try {
          if (!checkNetwork()) return;

          const res = await AxiosInstance.get(`module/purchase/${purchaseId}`);

          const data = res.data.results;

          // ✅ set full purchase
          setPurchaseData(data);
          sessionStorage.setItem("purchaseId", data._id);

          // ✅ set items & services
          setPurchaseItems(data.purchaseItems || []);
          setPurchaseServices(data.purchaseServices || []);
          if (data?.supplierId) {
            setSelectedCustomer(data?.supplierInfo);
            setCustomerData(data?.supplierInfo);
          } else {
            setSelectedCustomer(null);
            setCustomerData(null);
            setCustomerSearchTerm("");
            setCustomerSuggestions([]);
          }

          setTotalSoldRes({
            totalmrp: data?.grandTotal?.totalPurchaseMrp || 0,
            totaldiscount: data?.grandTotal?.totalPurchaseDiscount || 0,
            totalsaleprice: data?.grandTotal?.totalPurchasePrice || 0,
            grandtotal: data?.grandTotal?.grandtotal || 0,
          });
          setIsRounded(data?.isRounded || false);

          // ❌ DO NOT open create modal
          setAddModalOpen(false);
        } catch (err) {
          handleError(err, showAlert);
        }
      };

      fetchPurchase();

      // ✅ clear state AFTER using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.openCreateModal) {
      sessionStorage.removeItem("purchaseId");
      resetPurchaseState(); // ✅ double safety
    }
  }, [location.state]);

  useEffect(() => {
    // ❌ DO NOT run when creating new purchase
    if (location.state?.openCreateModal) return;

    if (location.state?.isEdit) return;

    const storedId = sessionStorage.getItem("purchaseId");
    if (!storedId) return;

    const fetchPurchase = async () => {
      try {
        if (!checkNetwork()) return;

        const res = await AxiosInstance.get(`module/purchase/${storedId}`);
        const data = res.data.results;

        setPurchaseData(data);
        setPurchaseItems(data.purchaseItems || []);
        setPurchaseServices(data.purchaseServices || []);
        if (data?.supplierId) {
          setSelectedCustomer(data?.supplierInfo);
          setCustomerData(data?.supplierInfo);
        } else {
          setSelectedCustomer(null);
          setCustomerData(null);
          setCustomerSearchTerm("");
          setCustomerSuggestions([]);
        }
        setTotalSoldRes({
          totalmrp: data?.grandTotal?.totalPurchaseMrp || 0,
          totaldiscount: data?.grandTotal?.totalPurchaseDiscount || 0,
          totalsaleprice: data?.grandTotal?.totalPurchasePrice || 0,
          grandtotal: data?.grandTotal?.grandtotal || 0,
        });
        setIsRounded(data?.isRounded || false);
      } catch (err) {
        handleError(err, showAlert);
      }
    };

    fetchPurchase();
  }, []);

  useEffect(() => {
    if (purchaseItems?.length) {
      const map = {};

      purchaseItems.forEach((item) => {
        map[item.code] = item.addToStock ?? true;
      });

      setAddToStockMap(map);
    }
  }, [purchaseItems]);

  useEffect(() => {
    setTotalPayable(
      isRounded
        ? totalSoldRes.grandtotal || 0
        : totalSoldRes.totalsaleprice || 0,
    );
  }, [isRounded, totalSoldRes.grandtotal, totalSoldRes.totalsaleprice]);

  useEffect(() => {
    if (location.state?.openCreateModal) {
      resetPurchaseState();

      setIsCreating(true); // ✅ IMPORTANT
      setAddModalOpen(true);
      setOpenedFromList(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  useEffect(() => {
    setIsTabsReady(true);
  }, []);

  useEffect(() => {
    isReload.current = false;
  }, []);

  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      return;
    }

    if (!isTabsReady) return;
    if (isEditMode.current) return;
    if (isCreating) return;
    if (isAddModalOpen) return;

    if (!purchaseData?._id) {
      onDone?.();
    }
  }, [purchaseData, isTabsReady]);
  // console.log("purchaseItems", purchaseItems);
  // console.log("purchaseServices", purchaseServices);
  const hasSelectedCustomer = !!selectedCustomer?._id;

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row py-0">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header px-3 py-3 d-flex justify-content-between align-items-start flex-wrap gap-3">
                    <div className="flex-grow-1">
                      <div className="d-flex gap-2 flex-wrap">
                        <div>
                          <button
                            type="button"
                            onClick={naviListEstimate}
                            className="btn btn-primary mt-2 mt-lg-0"
                          >
                            <ArrowBackIcon /> List Purchase
                          </button>
                        </div>
                        {/* ✅ Purchase No as disabled input */}
                        <div className="input-group" style={{ width: "250px" }}>
                          <span className="input-group-text">Purchase No</span>
                          <input
                            type="text"
                            className="form-control"
                            value={purchaseNo}
                            onChange={(e) => setPurchaseNo(e.target.value)}
                            // onBlur={() =>
                            //   updatePurchaseField("purchaseNo", purchaseNo)
                            // } // ✅ separate API call
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();

                                updatePurchaseField("purchaseNo", purchaseNo);

                                // ✅ remove focus from input
                                e.target.blur();
                              }
                            }}
                          />
                        </div>

                        {/* 📅 Purchase Date */}

                        <div className="input-group w-200" ref={datePickerRef}>
                          <button type="button" className="input-group-text">
                            <CalendarIcon />
                          </button>

                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              open={openDatePicker}
                              onOpen={() => setOpenDatePicker(true)}
                              onClose={() => setOpenDatePicker(false)}
                              value={
                                purchaseDate
                                  ? purchaseDate
                                  : dayjs(purchaseDate)
                              }
                              maxDate={dayjs(serverTime)}
                              format="DD MMM YYYY"
                              disableOpenPicker
                              onChange={(newValue) => {
                                const isoDateTime = newValue.toISOString();
                                setPurchaseDate(newValue);

                                // ✅ call API immediately when date selected
                                if (newValue) {
                                  updatePurchaseField(
                                    "purchaseDate",
                                    newValue.toISOString(),
                                  );
                                }
                                setOpenDatePicker(false);
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  className: "form-control cursor-pointer",
                                  inputProps: { readOnly: true },
                                  onClick: () => setOpenDatePicker(true),
                                  onKeyDown: (e) => e.preventDefault(),
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>

                        {/* <div className="input-group w-200">
                          <button className="input-group-text">
                            <i className="bx bx-calendar"></i>
                          </button>
                          <input
                            type="date"
                            className="form-control"
                            value={purchaseDate}
                            onChange={(e) => {
                              const value = e.target.value;
                              setPurchaseDate(value);

                              // ✅ call API immediately when date selected
                              if (value) {
                                updatePurchaseField("purchaseDate", value);
                              }
                            }}
                            // onBlur={() =>
                            //   updatePurchaseField("purchaseDate", purchaseDate)
                            // } // ✅ separate API call
                          />
                        </div> */}
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="position-relative">
                        {/* ✅ IF SUPPLIER SELECTED */}
                        {hasSelectedCustomer ? (
                          <div className="d-flex align-items-center justify-content-between border rounded px-2 py-2 bg-light">
                            <div className="d-flex flex-wrap align-items-center gap-2">
                              <span className="fw-600">
                                <UserIcon iClass={"fs-9 text-dark me-1"} />{" "}
                                {selectedCustomer.name}
                              </span>

                              <span className="badge bg-label-blue">
                                <PhoneIcon iClass={"fs-9 text-muted me-1"} />{" "}
                                {selectedCustomer.number}
                              </span>
                            </div>

                            <div className="d-flex align-items-center gap-3 border-0">
                              {/* Edit */}
                              <i
                                className="ng ng-ng-edit-icon cursor-pointer text-primary  shadow-none"
                                onClick={() => openEditModal(selectedCustomer)}
                              ></i>

                              {/* Remove */}
                              <i
                                className="ng ng-ng-remove-icon cursor-pointer text-danger shadow-none"
                                onClick={handleRemoveSupplier}
                              ></i>
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* 🔍 SEARCH INPUT */}
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search supplier..."
                                value={customerSearchTerm}
                                ref={customerSuggestionsRef}
                                onChange={(e) => {
                                  handleSupplierSearch(e.target.value);
                                  setShowCustomerDropdown(true);
                                  setHighlightedIndex(-1);
                                }}
                                onKeyPress={handleKeyPress}
                                onKeyDown={handleCustomerKeyDown}
                                onFocus={() => {
                                  if (customerSuggestions.length > 0) {
                                    setShowCustomerDropdown(true);
                                  }
                                }}
                              />

                              <button
                                className={`input-group-text ${customerSearchTerm.trim() ? "bg-label-prime" : ""}`}
                                // disabled={!value.trim()}
                                onClick={handleCustomerModalOpen}
                              >
                                <i
                                  className={`bx ${customerSearchTerm.trim() ? "bx-plus" : "bx-search"}`}
                                ></i>
                              </button>
                            </div>

                            {/* ❌ NO DATA */}
                            {customerSearchTerm &&
                              customerSuggestions.length === 0 && (
                                <ul className="suggestions-list">
                                  <li className="suggestion-item text-muted">
                                    No supplier found
                                  </li>
                                </ul>
                              )}

                            {/* 📋 DROPDOWN */}
                            {showCustomerDropdown &&
                              customerSuggestions.length > 0 && (
                                <ProductSearchList
                                  suggest={customerSuggestions}
                                  suggestionRefs={suggestionRefs}
                                  handleSelect={handleSelectCustomer}
                                  activeIndex={highlightedIndex}
                                  type="customer"
                                />
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-body mt-3 py-0">
                    <div className="row g-2">
                      <div
                        className="col-sm-3"
                        style={{ position: "relative" }}
                      >
                        <SearchInput
                          searchRef={suggestionsRef}
                          value={productSearchTerm}
                          onChange={(e) => {
                            handleProductSearch(e.target.value);
                            setShowProductDropdown(true);
                            setHighlightedIndex(0);
                          }}
                          onSearch={
                            productSearchTerm.trim()
                              ? () => {
                                  handleSelectNewProduct(
                                    productSearchTerm.trim(),
                                  );
                                  setShowNewProduct(true);
                                }
                              : null
                          }
                          placeholder="Search products by code, hsnsac, title..."
                          onKeyDown={handleProductKeyDown}
                        />

                        {/* <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            name="search"
                            ref={suggestionsRef}
                            autoComplete="off"
                            value={productSearchTerm}
                            onChange={(e) => {
                              handleProductSearch(e.target.value);
                              setShowProductDropdown(true);
                              setHighlightedIndex(0);
                            }}
                            onKeyDown={handleProductKeyDown}
                            onFocus={() => {
                              if (productSuggestions.length > 0) {
                                setShowProductDropdown(true);
                              }
                            }}
                            placeholder="Search products ..."
                            autoFocus
                          />
                          <button className="input-group-text">
                            <i className="bx bx-search"></i>
                          </button>
                        </div> */}
                        {productSearchTerm &&
                          productSuggestions.length === 0 && (
                            <ul className="suggestions-list">
                              <li className="suggestion-item text-muted">
                                No products data was found
                              </li>
                            </ul>
                          )}
                        {showProductDropdown &&
                          productSuggestions.length > 0 && (
                            <ProductSearchList
                              suggest={productSuggestions}
                              suggestionRefs={suggestionRefs}
                              handleSelect={handleSelectProduct}
                              activeIndex={highlightedIndex}
                            />
                          )}
                      </div>

                      <div className="col d-flex gap-2  justify-content-end">
                        {/* <button
                          className="btn shadow-none bg-label-service"
                          onClick={() => setShowNewProduct(true)}
                        >
                          <i className="ng ng-ng-add-icon"></i> New Product
                        </button> */}
                        <button
                          className="btn shadow-none bg-label-service"
                          onClick={() => handleServiceOpen()}
                        >
                          <AddIcon /> Service
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-body px-0">
                    <div className="table-responsive mt-0">
                      <>
                        <table className="table table-bordered align-middle mb-2">
                          <thead className="table-light">
                            <tr>
                              <th className="text-center">
                                {/* <input
                                  type="checkbox"
                                  // onChange={handleSelectAllProducts}
                                  // checked={areAllProductsSelected}
                                /> */}
                                <StockAddIcon /> Stock
                              </th>
                              <th className="text-center">S.No</th>
                              <th className="text-center">Barcode</th>
                              <th className="text-center">HSN</th>
                              <th className="w-40">Description</th>
                              <th className="text-center">MRP</th>
                              <th className="text-center">Rate / unit</th>
                              <th className="text-center">Qty</th>
                              <th className="text-center">Tax</th>
                              <th className="text-center">Tax Amount</th>
                              <th className="text-center">Discount</th>
                              <th className="text-center">Total BasePrice</th>
                              <th className="text-center">Total Price</th>

                              {/* <th className="text-center">Total</th> */}
                              <th className="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {purchaseItems.map((item, index) => (
                              <tr
                                key={item.imode + index}
                                className="position-relative cursor-pointer hover-row"
                                onClick={() => salepriceEdit(item, index)}
                              >
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    style={{
                                      transform: "scale(1.5)",
                                      cursor: "pointer",
                                    }}
                                    checked={
                                      addToStockMap.hasOwnProperty(item.code)
                                        ? addToStockMap[item.code]
                                        : (item.addToStock ?? true)
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={async (e) => {
                                      const checked = e.target.checked;

                                      // ✅ Optimistic UI
                                      setAddToStockMap((prev) => ({
                                        ...prev,
                                        [item.code]: checked,
                                      }));

                                      await updateAddToStock(
                                        item._id,
                                        checked,
                                        item.code,
                                      );
                                    }}
                                  />
                                </td>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{item.code}</td>
                                <td className="text-center">
                                  {item.hsnsac || "-"}
                                </td>
                                <td className="text-wrap" width="280">
                                  <div className=" align-items-start">
                                    <div className="me-2">{item.title}</div>
                                    <div className="ms-0 mt-1 fs-12 text-truncate-description text-muted d-flex align-items-start">
                                      <button
                                        type="button"
                                        className="me-2 rounded btn-label-primary shadow-none border-0"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleProductNote(item);
                                        }}
                                      >
                                        <NotepadIcon />
                                      </button>

                                      {item.note && <span>{item.note}</span>}
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.purchaseMrp || 0,
                                    "INR",
                                  )}
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.purchasePriceWithTax || 0,
                                    "INR",
                                  )}{" "}
                                  / {item.unitConfig?.primaryUnitCode || "Unit"}
                                </td>
                                <td className="text-center">
                                  {item?.isSecondaryUnit
                                    ? `${
                                        toSecondaryQuantity(
                                          item.purchaseQuantity || 0,
                                          item?.unitConfig || {},
                                        )?.secondaryQty
                                      } ${item?.unitConfig?.secondaryUnitCode || ""}`
                                    : `${item.purchaseQuantity || 0} ${item?.unitConfig?.primaryUnitCode || ""}`}
                                </td>
                                <td className="text-center">
                                  {item?.purchaseTaxPercentage}%
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.purchaseTaxAmount || 0,
                                    "INR",
                                  )}
                                </td>

                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.purchaseDiscount || 0,
                                    "INR",
                                  )}
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.lineTotalPurchasePriceWithoutTax || 0,
                                    "INR",
                                  )}
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item.lineTotalPurchasePriceWithTax || 0,

                                    "INR",
                                  )}
                                </td>

                                <td className="text-center">
                                  <div className="order-actions">
                                    <button
                                      className="btn-label-primary shadow-none me-2"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        salepriceEdit(item, index);
                                      }}
                                    >
                                      <EditIcon />
                                    </button>
                                    <button
                                      className="btn-label-danger shadow-none"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeItem(item._id);
                                      }}
                                    >
                                      <DeleteIcon />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="fw-600 text-center bg-gray">
                          {" "}
                          SERVICE{" "}
                        </div>

                        {/* 🧾 SERVICE & RECHARGE TABLE */}
                        <table className="table table-bordered align-middle ">
                          <thead className="table-light">
                            <tr>
                              <th className="text-center">S.No</th>
                              {/* <th className="text-center">Barcode</th> */}
                              <th className="text-center">HSN</th>
                              <th className="w-40">Description</th>
                              {/* <th className="text-center">MRP</th> */}
                              <th className="text-center">Tax</th>
                              <th className="text-center">Total BasePrice</th>
                              <th className="text-center">Total Price</th>
                              {/* <th className="text-center">Sale Price</th>
                              <th className="text-center">Qty</th> */}
                              {/* <th className="text-center">Total</th> */}
                              <th className="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {purchaseServices
                              ?.filter((item) => item.imode === "SERVICE")
                              .map((item, index) => (
                                <tr
                                  key={item.imode + index}
                                  className="position-relative cursor-pointer hover-row"
                                  onClick={() => {
                                    if (item.imode === "SERVICE")
                                      editItem(item, index);
                                  }}
                                >
                                  <td className="text-center">
                                    {index + 1}
                                    <i
                                      className={`bx bxs-circle ms-1 fsz-10 ${
                                        item.imode === "SERVICE"
                                          ? "text-yellow"
                                          : "text-info"
                                      }`}
                                    ></i>
                                  </td>
                                  <td className="text-center">
                                    {item.hsnsac || "-"}
                                  </td>
                                  {/* <td className="text-center">{item.code}</td> */}
                                  <td className="text-wrap" width="280">
                                    <div className="align-items-start">
                                      <div className="me-2">{item.title}</div>
                                      {item.description && (
                                        <div className="ms-0 mt-1 fs-12 text-truncate-description">
                                          {item.description}
                                        </div>
                                      )}
                                    </div>
                                  </td>

                                  {/* <td className="text-center">
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      item.mrp || 0,
                                      "INR",
                                    )}
                                  </td> */}
                                  {/* <td className="text-center">
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      item.discount || 0,
                                      "INR",
                                    )}
                                  </td> */}
                                  <td className="text-center">
                                    {item?.purchaseTaxPercentage}%
                                  </td>
                                  <td className="text-center">
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      item.lineTotalPurchasePriceWithoutTax ||
                                        0,
                                      "INR",
                                    )}
                                  </td>
                                  {/* <td className="text-center">
                                    {item.quantity}
                                  </td> */}
                                  <td className="text-center">
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      item.lineTotalPurchasePriceWithTax || 0,
                                      "INR",
                                    )}
                                  </td>
                                  {/* <td className="text-center">
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      item.totalAmount || 0,
                                      "INR",
                                    )}
                                  </td> */}
                                  <td className="text-center">
                                    <div className="order-actions">
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          editItem(item, index);
                                        }}
                                      >
                                        <EditIcon />
                                      </button>
                                      <button
                                        className="btn-label-danger shadow-none"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          removeService(item._id);
                                        }}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </>
                    </div>

                    <div className="row bg-light border-0  text-center align-items-center m-0">
                      <div className="col p-2">
                        <p className="mb-0">Total MRP</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalmrp || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <MinusIcon iClass={"text-muted"} />
                      </div>
                      <div className="col p-2">
                        <p className="mb-0">Total Discount</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totaldiscount || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <LineDoubleIcon iClass={"text-muted"} />
                      </div>
                      <div className="col bg-dark-shine p-1 radius-10">
                        <p className="mb-0 bg-dark-shine">Total Amount</p>
                        <h6 className="mb-0 bg-dark-shine fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalsaleprice || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <LineDoubleIcon iClass={"text-muted"} />
                        <LniChevronRightIcon iClass={"text-muted"} />
                      </div>
                      <div className="col bg-dark-blue p-1">
                        <p className="mb-0 bg-dark-text fw-600 d-flex align-items-center justify-content-center gap-1">
                          Grand Total
                        </p>

                        <small className="fs-12 mt-0 d-flex align-items-center justify-content-center gap-1">
                          <input
                            type="checkbox"
                            checked={isRounded}
                            onChange={(e) => {
                              setIsRounded(e.target.checked);
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          (Rounded)
                        </small>

                        <h6 className="mb-0 bg-dark-text fs-20 fw-600">
                          {CurrencyConverter.toCurrency(
                            isRounded
                              ? totalSoldRes.grandtotal || 0
                              : totalSoldRes.totalsaleprice || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer d-block mb-2 ">
                    <button
                      type="button"
                      className="btn shadow-none btn-outline-secondary text-left ms-2"
                      onClick={handleCancel}
                    >
                      <XIcon iClass={"fs-15"} /> Close
                    </button>
                    {isbtnLoading ? (
                      <button
                        className="btn btn-primary pb-0 text-right"
                        disabled
                      >
                        <CircularProgress size={22} className="text-white" />
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary me-2 text-right"
                        onClick={() => {
                          // setSubmitType("DRAFT");
                          setShowPaymentPopup(true);
                        }}
                      >
                        <CheckIcon /> Proceed
                      </button>
                    )}
                    <button
                      className="btn btn-outline-primary shadow-none text-right me-4"
                      onClick={handleCancel}
                    >
                      <CheckIcon /> Save as Draft
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showNewProduct && (
            <AddNewProduct
              onClose={() => setShowNewProduct(false)}
              onSubmit={addNewProductToPurchase}
              isActive={isActive}
              noteOpenStatus={handleNoteOpen}
              noteSuggests={noteSuggest}
              setIsAnyInputFocused={setIsAnyInputFocused}
              brandSuggest={brandSuggest}
              setBrandSuggest={setBrandSuggest}
              initialData={isProductData}
            />
          )}

          <PaymentConfirmPopup
            open={showPaymentPopup}
            totalPayable={totalPayable}
            isRounded={isRounded}
            onClose={() => {
              setShowPaymentPopup(false);
              suggestionsRef.current?.focus();
            }}
            onDone={async (paymentData) => {
              try {
                const { cash, upi, card, credit, others } = paymentData;

                const paymentMode = [];

                if (cash > 0) {
                  paymentMode.push({
                    mode: "CASH",
                    amount: CurrencyConverter.toSubunit(cash, "INR"),
                  });
                }

                if (upi > 0) {
                  paymentMode.push({
                    mode: "UPI",
                    amount: CurrencyConverter.toSubunit(upi, "INR"),
                  });
                }

                if (card > 0) {
                  paymentMode.push({
                    mode: "CARD",
                    amount: CurrencyConverter.toSubunit(card, "INR"),
                  });
                }

                if (others > 0) {
                  paymentMode.push({
                    mode: "OTHERS",
                    amount: CurrencyConverter.toSubunit(others, "INR"),
                  });
                }

                const creditAmount = CurrencyConverter.toSubunit(
                  credit || 0,
                  "INR",
                );

                // ✅ VALIDATION
                if (paymentMode.length === 0 && creditAmount <= 0) {
                  showAlert("error", "Enter payment or credit amount.");
                  return;
                }

                const purchaseId = purchaseData?._id;

                // ✅ BUILD PAYLOAD CONDITIONALLY
                const payload = {
                  isRounded: paymentData.isRounded,
                };

                if (paymentMode.length > 0) {
                  payload.paymentMode = paymentMode;
                }

                if (creditAmount > 0) {
                  payload.creditAmount = creditAmount;
                }

                await AxiosInstance.patch(
                  `/module/purchase/payment/${purchaseId}`,
                  payload,
                );

                setPurchaseIdForSubmit(purchaseId);
                setShowSubmitConfirm(true);
                showAlert("success", "Payment added successfully.");
              } catch (error) {
                showAlert("error", "validation error");
              }
            }}
          />

          <ConfirmSubmitModal
            open={showSubmitConfirm}
            onClose={() => {
              setShowSubmitConfirm(false);
              setShowPaymentPopup(false);
              suggestionsRef.current?.focus(); // stays as draft
            }}
            onConfirm={async () => {
              try {
                const res = await AxiosInstance.patch(
                  `/module/purchase/submit/${purchaseIdForSubmit}`,
                );

                setShowSubmitConfirm(false);
                setShowPaymentPopup(false);
                  const updatedPurchaseData = res.data?.results;
                  if (updatedPurchaseData) {                 
                    setPurchaseData(updatedPurchaseData);
                  }
                setIsViewModalOpen(true);
                // ✅ Navigate to purchase list
                // navigate("/listpurchase"); // adjust route if needed
              } catch (err) {
                console.error(err);
              }
            }}
          />
                 {isViewModalOpen && (                
                    <TemplateModalLayout
                    isOpen={isViewModalOpen}
                    isData={purchaseData}
                    onClose={handleCancel}                    
                    selectedOption={selectedPurchaseOption}
                    setSelectedOption={setSelectedPurchaseOption}                   
                    isPurchase={true}
                    />
                  )}
          {isQuantityModalOpen && (
            <UpdateQty
              data={isQuantityData}
              ItemIndex={isQuantityIndex}
              updateQuantity={handleQuantityUpdate}
              onClose={handleQuantityClose}
            />
          )}
          {isSoldPirceModalOpen && (
            <AddStockModel
              onData={isProductData}
              onStockAdd={handleStockAdded}
              onclose={handleSoldPriceClose}
            />
          )}
          <AddSupplier
            isActive={isActive}
            isOpen={isCustomerModalOpen}
            onClose={handleCustomerModalClose}
            onData={isCustomerData}
            onAdd={handleCustomerAdd}
            isBtnLoading={isBtnLoading}
            groupName={groupName}
            // onNewGroupsIn={handleCustomerGroupAdd}
            // newGroup={newGroupName}
            resetAll={true}
            error={error}
            setErrors={setErrors}
            numberSuggest={numberSuggest}
            addNewCustomNumber={addNewCustomNumber}
          />
          {isEditModalOpen && (
            <EditSupplier
              isActive={isActive}
              editData={isEditData}
              onClose={closeEditModal}
              onEdit={handleUpdte}
              isBtnLoading={isBtnLoading}
              groupName={groupName}
              // onNewGroupsIn={handleCustomerGroupAdd}
              resetAll={true}
              // newGroup={newGroupName}
              error={error}
              setErrors={setErrors}
            />
          )}

          {isProductModalOpen && (
            <AddProductSearch
              // onAdd={() => addProduct()} // for footer button
              onClose={handleProductClose}
              isBtnLoading={isBtnLoading}
              productSearchTerm={productSearchTerm}
              handleProductSearch={handleProductSearch}
              productSuggestions={productSuggestions}
              handleSelectProduct={handleSelectProduct}
              handleProductKeyDown={handleProductKeyDown}
              showProductDropdown={showProductDropdown}
              setShowProductDropdown={setShowProductDropdown}
              highlightedIndex={highlightedIndex}
              setHighlightedIndex={setHighlightedIndex}
              catalogItems={categories}
            />
          )}

          {isServiceModalOpen && (
            <AddService
              isActive={isActive}
              onClose={handleServiceClose}
              onAdd={addServiceToPurchase}
              isBtnLoading={isBtnLoading}
              estimateSuggest={estimateSuggest}
              serviceNameSuggests={serviceNameSuggest}
              addNewServiceName={addNewServiceName}
              isServiceName={true}
              showQuanity={false}
            />
          )}

          {isEditServiceModalOpen && (
            <EditService
              isActive={isActive}
              onClose={handleEditServiceClose}
              onUpdate={UpdateServiceToPurchase}
              editData={isServiceData}
              isBtnLoading={isBtnLoading}
              estimateSuggest={estimateSuggest}
              serviceNameSuggests={serviceNameSuggest}
              addNewServiceName={addNewServiceName}
              isServiceName={true}
              showQuanity={false}
            />
          )}

          {isEditSalePriceModelOpen && (
            <EditStockModel
              onclose={editSalePriceClose}
              onStockUpdate={(data) =>
                handleStockItemUpdate(data, isEditSalePriceData?._id)
              }
              stockItem={isEditSalePriceData}
            />
          )}

          {isAddModalOpen && (
            <AddPurchase
              isActive={isActive}
              onClose={handleAddPurchaseClose}
              handleAdd={handleCreatePurchase}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default Purchase;
